// extracted by mini-css-extract-plugin
module.exports = {"flex_column":"ChartSlide_flex_column__37min","slide":"ChartSlide_slide__p8-Wm","title":"ChartSlide_title__1SnKT"};